import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Spin, DatePicker } from 'antd';
import { Formik } from 'formik';
import { Form } from 'formik-antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Button from '~/components/Button';
import FormControl from '~/components/Form/FormControl';
import Row from '~/components/Row';
import errorHandler from '~/Utils/errorHandler';

const { RangePicker } = DatePicker;
const DATE_FORMAT = 'YYYY-MM-DD';

const styles = {
  btnSubmit: { marginLeft: 10, marginRight: 10, marginTop: 25 },
  btnClear: { marginLeft: 'auto', marginTop: 25 },
};

export default function Filter({ isLoading, setFilters }) {
  const { t } = useTranslation();

  const initialValues = {
    architectsProjectNumberFilter: '',
    dateRange: [null, null], // array [Moment | null, Moment | null]
  };

  const handleSearch = values => {
    const filtersArray = [];

    try {
      const [startMoment, endMoment] = values.dateRange;

      if (startMoment) {
        filtersArray.push({
          field: 'date',
          value: startMoment.format(DATE_FORMAT),
          restriction: 'GREATER_THAN_OR_EQUAL_TO',
        });
      }

      if (endMoment) {
        filtersArray.push({
          field: 'date',
          value: endMoment.format(DATE_FORMAT),
          restriction: 'LESS_THAN_OR_EQUAL_TO',
        });
      }

      // if (values.architectsProjectNumberFilter && values.architectsProjectNumberFilter !== '0') {
      //   filtersArray.push({
      //     field: 'architectsProjectNumber',
      //     value: values.architectsProjectNumberFilter,
      //     restriction: 'EQUAL',
      //   });
      // }

      setFilters(filtersArray);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSearch}>
      {({ values, setFieldValue, resetForm, submitForm }) => (
        <Spin spinning={isLoading}>
          <Form layout="vertical">
            <Row wrap={false}>
              <FormControl
                cols={{ xs: 24, sm: 24, md: 12, lg: 10, xl: 8 }}
                field="dateRange"
                label={t('screens:invoices.data.date')}
              >
                <RangePicker
                  format={DATE_FORMAT}
                  value={[
                    values.dateRange[0] ? moment(values.dateRange[0], DATE_FORMAT) : null,
                    values.dateRange[1] ? moment(values.dateRange[1], DATE_FORMAT) : null,
                  ]}
                  onChange={dates => {
                    setFieldValue('dateRange', dates || [null, null]);
                  }}
                />
              </FormControl>

              <Button
                type="button"
                color="default"
                style={styles.btnClear}
                onClick={() => {
                  resetForm();
                  setFilters([]); 
                }}
              >
                {t('screens:dateSearch.clearButton')}
              </Button>

              <Button
                type="primary"
                htmlType="submit"
                color="primary"
                style={styles.btnSubmit}
                icon={<SearchOutlined />}
                onClick={submitForm}
              >
                {t('screens:dateSearch.button')}
              </Button>
            </Row>
          </Form>
        </Spin>
      )}
    </Formik>
  );
}